import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button, Dropdown, Icon, Input, Loader, Tab } from 'semantic-ui-react';
import GConf from '../AssetsM/generalConf';
// import FrameForPrint from '../../AssetsM/Cards/frameForPrint';
// import usePrintFunction from '../../AssetsM/Hooks/printFunction';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import timeGridPlugin from '@fullcalendar/timegrid';
import { NavLink, useParams } from 'react-router-dom';

const AddEmploiDataCard = ({ emploiNow, setEmploiNow,  AddEmploiToListe}) =>{
    const jourListeLocal = [
        {key : 7 , value :'Dim', text:'Dimanche'},
        {key : 1 , value :'Lun', text:'Lundi'},
        {key : 2 , value :'Mar', text:'Mardie'},
        {key : 3 , value :'Mer', text:'Mercredie'},
        {key : 4 , value :'Jeu', text:'Jeudi'},
        {key : 5 , value :'Ven', text:'Vendredie'},
        {key : 6 , value :'Sam', text:'Samedie'} 
    ]

    const SelectSubjectFunct = (selectedItem) => {
        const selectedItemData = GConf.matiereListe.find(item => item.value === selectedItem);
        setEmploiNow({...emploiNow, matiere: selectedItem , matiereName: selectedItem})
    }

    const SelectSalleFunct = (selectedItem) => {
        const selectedItemData = GConf.salleListe.find(item => item.value === selectedItem);
        setEmploiNow({...emploiNow, salle: selectedItem , salleName : selectedItem})
    }

    const SelecGrpFunct = (selectedItem) => {
        const selectedItemData = GConf.groupeListe.find(item => item.grid === selectedItem);
        setEmploiNow({...emploiNow, groupe: selectedItem , groupeName : selectedItemData.grp})
    }
    
    const SelectTiming = (horData) => {
        setEmploiNow({...emploiNow, de: horData.de, vers : horData.vers })
    }
    
    return (<>
                <div className='card card-body shadow-sm mb-2'>

                <h5 className='mt-2 mb-0'>Jour</h5> 
                    <Dropdown
                        //search
                        selection
                        wrapSelection={false}
                        options={jourListeLocal}
                        placeholder='Selectionnez Jour'
                        className='mb-1'
                        onChange={(e, { value }) =>  setEmploiNow({...emploiNow, Jour: value })}
                        value={emploiNow.Jour}
                    /> 
                    
                    <div className='row mt-1'>
                        <div className='col-6'>
                            <h5 className='mb-0'>De</h5> 
                            <Input icon='barcode' type='time'  value={emploiNow.de || ''}  onChange={ (e) =>  setEmploiNow({...emploiNow, de: e.target.value })} size="small" iconPosition='left'    fluid className='mb-1' />
                        </div>
                        <div className='col-6'>
                            <h5 className='mb-0'>Vers</h5> 
                            <Input icon='barcode' type='time' value={emploiNow.vers || ''}  onChange={ (e) =>  setEmploiNow({...emploiNow, vers: e.target.value })} size="small" iconPosition='left'    fluid className='mb-1' />
                        </div>
                        <div className='col-12'>
                            <Dropdown
                                search
                                selection
                                wrapSelection={false}
                                options={GConf.horaireListe.map((data, index) => ({id : index, value: data, text:data.hnom }))}
                                placeholder='Selectionnez Horaire'
                                className='mb-1 w-100'
                                onChange={(e, { value }) => SelectTiming(value)}
                                //value={emploiNow.matiere}
                            />
                        </div>
                    </div>
                    <h5 className='mb-0 mt-1'>Matiére</h5>
                    <Dropdown
                        search
                        selection
                        wrapSelection={false}
                        options={GConf.matiereListe.map((data, index) => ({id : index, value: data.nom, text:data.nom }))}
                        placeholder='Selectionnez Matiere'
                        className='mb-1'
                        onChange={(e, { value }) => SelectSubjectFunct(value)}
                        value={emploiNow.matiere}
                    />
                    <h5 className='mb-0 mt-1'>Groupe</h5>
                    <Dropdown
                        search
                        selection
                        wrapSelection={false}
                        options={GConf.groupeListe.map((data, index) => ({id : index, value: data.grid, text:`${data.spec} - ${data.grp} ` }))}
                        placeholder='Selectionnez Groupe'
                        className='mb-1'
                        onChange={(e, { value }) => SelecGrpFunct(value)}
                        value={emploiNow.groupe}
                    />

                    <h5 className='mb-0 mt-1'>Salle</h5>
                    <Dropdown
                        search
                        selection
                        wrapSelection={false}
                        options={GConf.salleListe.map((data, index) => ({id : index, value: data.nom, text:data.nom }))}
                        placeholder='Selectionnez Salle'
                        className='mb-1'
                        onChange={(e, { value }) => SelectSalleFunct(value)}
                        value={emploiNow.salle}
                    />
                    <br />
                    <Button  className='rounded-pill bg-system-btn' onClick={() => AddEmploiToListe()}>  <Icon name='edit outline' /> Ajouter</Button>
                </div>
    </>)
}
 
function AjouterEmploi() {
   /* ############################### Const ################################*/
    let Today = new Date()
    let {idp} = useParams();
    let [defaultEmploi, setDefaultEmploi] = useState([])
    let [listeToShow, setListeToShow] = useState([])
    let [fullMatiereList, setFullMatiereList] = useState([]);
    let [emploiNow, setEmploiNow] = useState({de: new Date().toLocaleTimeString([],{ hourCycle: 'h23'}), vers: new Date().toLocaleTimeString([],{ hourCycle: 'h23'}),}) ; 

    let [saveBtnState, setSaveBtnState] = useState(false) ; 
 
 
    const [loaderState, setLS] = useState(false)
    const jourListe = [
        {id:0, value :'Dim', text:'Dimanche'},
        {id:1, value :'Lun', text:'Lundi'},
        {id:2, value :'Mar', text:'Mardie'},
        {id:3, value :'Mer', text:'Mercredie'},
        {id:4, value :'Jeu', text:'Jeudi'},
        {id:5, value :'Ven', text:'Vendredie'},
        {id:6, value :'Sam', text:'Samedie'},
        
    ]
 
    const panes = [
        {
            menuItem: { key: 'start', icon: 'add circle', content: 'Entrer ' }, 
            render: () =><AddEmploiDataCard emploiNow={emploiNow} setEmploiNow={setEmploiNow}  AddEmploiToListe={AddEmploiToListe} />,
        },
        {
            menuItem: { key: 'save', icon: 'save outline', content:  'Enregistrer' }, 
            render: () =><FinishSaveCard />,
        },
 
        
    ]

   /* ############################### UseEffect ########################*/
    useEffect(() => {
        axios.post(`${GConf.ApiLink}/Admin/select-prof-emploi`, {
            idp :  idp,
        })
        .then(function (response) {
            console.log(response.data)
            setDefaultEmploi(JSON.parse(response.data.p_emploi) !== "" ? JSON.parse(response.data.p_emploi) : [])
            GeneratedTime(JSON.parse(response.data.p_emploi) !== "" ? JSON.parse(response.data.p_emploi) : [])
        })
        
    },[])
    /* ########################## Functions ############################*/
    const findIdByValue = (value) => {
        const jour = jourListe.find(jour => jour.value === value);
        return jour ? jour.id : null;
    }

    const AddEmploiToListe = ()=>{
        if (!emploiNow.Jour) {toast.error("Date Invalide !", GConf.TostErrorGonf)}
        else if (!emploiNow.de ) {toast.error("de Invalide  !", GConf.TostErrorGonf)}
        else if (!emploiNow.vers ) {toast.error("Vers Invalide !", GConf.TostErrorGonf)}
        else if (!emploiNow.matiere ) {toast.error("Matiere Invalide !", GConf.TostErrorGonf)}
        else if (!emploiNow.salle) { toast.error("Salle Invalide !", GConf.TostErrorGonf) }
        else if (!emploiNow.groupe) { toast.error("Groupe Invalide !", GConf.TostErrorGonf) }
        else{
            const searchObject = defaultEmploi.find((article) => article.day == emploiNow.Jour);
            if (searchObject) {
                let seanceListe = {de: emploiNow.de ,vers: emploiNow.vers , matiere: emploiNow.matiere , matiereName:emploiNow.matiereName, salle: emploiNow.salle , salleName: emploiNow.salleName, groupe: emploiNow.groupe , groupeName: emploiNow.groupeName, proff: emploiNow.proff , proffName: emploiNow.proffName , genre: 'normale'}
            
                searchObject.seances.push(seanceListe)
                 
                setEmploiNow({Jour: emploiNow.Jour , de: emploiNow.de, vers: emploiNow.vers, proff:'', proffName:'', salle:'', salleName:'', groupe:'', groupeName:'', matiere:'', matiereName:'', matiereColor:''})
                GeneratedTime(defaultEmploi)

            } else {
            let arrayToAdd = { day : emploiNow.Jour ,   dayOff :false, seances : []}
            let seanceListe = {de: emploiNow.de ,vers: emploiNow.vers , matiere: emploiNow.matiere , matiereName:emploiNow.matiereName, salle: emploiNow.salle , salleName: emploiNow.salleName,  groupe: emploiNow.groupe , groupeName: emploiNow.groupeName, proff: emploiNow.proff ,  proffName: emploiNow.proffName, genre: 'normale'}
            
            arrayToAdd.seances.push(seanceListe)
            defaultEmploi.push(arrayToAdd)
            setEmploiNow({Jour: emploiNow.Jour , de: emploiNow.de, vers: emploiNow.vers, proff:'', proffName:'', salle:'', salleName:'', groupe:'', groupeName:'', matiere:'', matiereName:'', matiereColor:''})
            GeneratedTime(defaultEmploi)
        }
        

        }
    }
 
    const SaveEmploiToProf = () =>{
         
            if (!defaultEmploi) {toast.error("Proff est Invalide !", GConf.TostErrorGonf)}
            else {
                setLS(true)
                setSaveBtnState(true)
                axios.post(`${GConf.ApiLink}/Admin/update-prof-emploi`, {
                    idp: idp,
                    p_emploi : defaultEmploi,
                })
                .then(function (response) {
                    console.log(response.data)
                    if(response.status = 200) { 
                        toast.success("Fonds enregistreé !", GConf.TostSuucessGonf)
                        //setBonID(response.data.BonID)
                        setLS(false)
                    }
                    else{
                        toast.error('Erreur esseyez de nouveaux', GConf.TostSuucessGonf)
                        setLS(false)
                        setSaveBtnState(false)
                    }
                }).catch((error) => {
                    if(error.request) {
                       
                    }
                  });
            }       
    }
    const PrintFunction = (frameId) =>{ alert(frameId)}

    const GeneratedTime = (listeValue) => {
        let curr = new Date()
        let first = curr.getDate() - curr.getDay()
        const TargertDateIs = (dayIndex) => { return new Date(curr.setDate(first + dayIndex)).toLocaleDateString('fr-FR').split( '/' ).reverse( ).join( '-' )}
        
        const TargertColor = (matiere) => { 
            let targetMat = GConf.matiereListe.find((data) => data.nom === matiere)
            if (targetMat) {
                return targetMat.matCol
            } else{
                return '#7f7f7f'
            }
        }

        let reternedListe = []
        listeValue.map( (getData,index) => (
            getData.seances.map((data) =>  reternedListe.push({ title: `${data.matiereName} (${data.salleName})`,  start: `${TargertDateIs(findIdByValue(getData.day))}T${data.de}` , end: `${TargertDateIs(findIdByValue(getData.day))}T${data.vers}`,  className:'border-0 rounded-0 m-0 p-0', backgroundColor:  TargertColor(data.matiere), removeID: data, removeIDDay: getData.day })) 
        ))         
        setListeToShow(reternedListe)
        
    }
    const RemoveEvent = (eventId) => {
         
        const userConfirmed = window.confirm('vouler vous vraimment supprimer cette seance : de ' + eventId.extendedProps.removeID.de + ' vers ' + eventId.extendedProps.removeID.vers)
        if (userConfirmed) {
                let targetDay = defaultEmploi.find((item) => item.day == eventId.extendedProps.removeIDDay);
                let emploiTemplate = targetDay.seances.filter(item => 
                    item.de !== eventId.extendedProps.removeID.de || 
                    item.vers !== eventId.extendedProps.removeID.vers
                );
                targetDay.seances = emploiTemplate
                 
                GeneratedTime(defaultEmploi)
        } else {
            
        }
    }
    /* ############################### card ################################*/
    const MainTopCard = () =>{
        return(<>
            <div className='card p-3 fixed-top border-0 shadow-sm  rounded-0'>
                <div className='row'>
                    <div className='col-4 align-self-center'>
                        <NavLink exact='true' to='/Admin/L'>
                            <span className='bi bi-arrow-left-short bi-md text-primary'></span>
                        </NavLink>

                    </div>
                    <div className='col-8 align-self-center text-end' ><h2> <span className="badge bg-info"> <span className='bi bi-building '></span>  Administration </span></h2></div>
                    
                </div>
            </div>
        </>)
    }
 
    const FinishSaveCard = () =>{
            return (<>
                <div className='card card-body shadow-sm mb-2'>
                    <h5>Buttons</h5>
                    <div className='row mb-2'>
                        <div className='col-6'>
                            <Button disabled={saveBtnState} className='rounded-pill  bg-system-btn'  fluid onClick={SaveEmploiToProf}><Icon name='save' /> Enregistrer <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                        </div>
                        <div className='col-6'>
                            <Button  className='rounded-pill btn-imprimer' disabled={!saveBtnState}  fluid onClick={ (e) => PrintFunction('PrintFond') }><Icon name='print' /> Imprimer</Button>
                        </div>
                        
                    </div>
                </div>
        </>)
    }
 
    return ( <>
           <MainTopCard />
            <br />                
            <br />                
            <br />                
            <br />   
                   
            <div className='container'>
                <div className='row'>
                    <div className='col-12 col-lg-5'>
                        <div className="mb-4 sticky-top" style={{top:'70px', zIndex: 1}}>
                            <Tab menu={{  pointing: true  }} panes={panes} />
                        </div>
                    </div>
                    <div className='col-12 col-lg-7'>
                            <FullCalendar 
                                plugins={[ timeGridPlugin ]}
                                initialView="timeGridWeek"
                                locale='fr' 
                                dayHeaderFormat = {{weekday: 'short'}}
                                events={listeToShow}
                                eventClick={(clickInfo) => RemoveEvent(clickInfo.event)}
                                headerToolbar='false'
                                height='490px'
                                allDaySlot= {false}
                                slotMinTime = '08:00'  
                                slotMaxTime = '18:00' 
                            /> 
                    </div>
                </div>
                {/* <FrameForPrint frameId='PrintFond' src={`/Pr/Camion/Fonds/fondTemp/${gettedBonID}`} /> */}
            </div>
        </> );
    }

export default AjouterEmploi;